import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScheduleReminderSmartComponent } from './schedule-reminder-smart/schedule-reminder-smart.component';
import { ScheduleReminderFullComponent } from './schedule-reminder-full/schedule-reminder-full.component';
import { ScheduleReminderBorrowerComponent } from './schedule-reminder-borrower/schedule-reminder-borrower.component';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatButtonModule } from '@angular/material/button';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { ScheduleReminderFormComponent } from './schedule-reminder-form/schedule-reminder-form.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FormlyMaterialModule } from '@ngx-formly/material';
import { FormlyModule } from '@ngx-formly/core';
import { BorrowerSearchInputModule } from 'app/borrower-search-input/borrower-search-input.module';
import { AlertModule } from 'app/components/alert/alert.module';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ScheduleReminderDialogSmartComponent } from './schedule-reminder-dialog-smart/schedule-reminder-dialog-smart.component';
import { BorrowerAlertsModule } from 'app/borrower-alerts/borrower-alerts.module';
import { RouterModule } from '@angular/router';
import { MatDialogModule } from '@angular/material/dialog';
@NgModule({
  declarations: [
    ScheduleReminderSmartComponent,
    ScheduleReminderFullComponent,
    ScheduleReminderBorrowerComponent,
    ScheduleReminderFormComponent,
    ScheduleReminderDialogSmartComponent
  ],
    imports: [
        CommonModule,
        BorrowerAlertsModule,
        MatGridListModule,
        MatButtonModule,
        MatProgressSpinnerModule,
        MatIconModule,
        CalendarModule.forRoot( {
            provide: DateAdapter,
            useFactory: adapterFactory,
        } ),
        MatMenuModule,
        FormsModule,
        ReactiveFormsModule,
        FormlyMaterialModule,
        FormlyModule,
        BorrowerSearchInputModule,
        MatIconModule,
        AlertModule,
        MatTooltipModule,
        RouterModule,
        MatDialogModule,
    ],
  exports: [
    ScheduleReminderSmartComponent,
    ScheduleReminderDialogSmartComponent
  ]
})
export class ScheduleReminderModule { }
